import { EXEMPTION_TYPES, STATUS, UNIT_STOCK_TYPE } from './chunk-3A7OUQGO.mjs';

// helpers/offerings.ts
var OfferingDisplayStatus = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  IN_REVIEW: "In Review",
  CLOSED: "Closed",
  TERMINATED: "Terminated"
};
var offeringIsRegD = (offering) => {
  return [EXEMPTION_TYPES.REG_D_506_B, EXEMPTION_TYPES.REG_D_506_C, EXEMPTION_TYPES.REG_D_504_B].includes(
    offering?.exemption_type
  );
};
var offeringDisplayStatus = (status) => {
  if (!status) return "";
  return OfferingDisplayStatus[status] ?? "";
};
var offeringIsRegA = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.REG_A;
};
var offeringIsRegAPlus = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.REG_A_PLUS;
};
var offeringIsTypeRegA = (offering) => {
  return offeringIsRegA(offering) || offeringIsRegAPlus(offering);
};
var offeringIsIPO = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.IPO;
};
var offeringIsRegS = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.REG_S;
};
var offeringIsRule506c = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.REG_D_506_C;
};
var offeringIsRule506b = (offering) => {
  return offering?.exemption_type === EXEMPTION_TYPES.REG_D_506_B;
};
var offeringIsActive = (offering) => {
  return offering?.status === STATUS.ACTIVE;
};
var offeringIsDraft = (offering) => {
  return offering?.status === STATUS.DRAFT;
};
var offeringIsTerminated = (offering) => {
  return offering?.status === STATUS.TERMINATED;
};
var offeringIsClosed = (offering) => {
  return offering?.status === STATUS.CLOSED;
};
var offeringIsCompleted = (offering) => {
  return offeringIsClosed(offering) || offeringIsTerminated(offering);
};
var offeringInactiveWarning = (offering) => {
  if (!offering?.status || offeringIsActive(offering)) return null;
  if (offeringIsTerminated(offering)) return "This offering has been terminated.";
  if (offeringIsClosed(offering)) return "This offering is closed.";
  return "This offering is not active yet.";
};
var offeringIsUnitType = (offering) => {
  return offering?.stock_type === UNIT_STOCK_TYPE;
};
var offeringHasNoAccreditationStep = (offering) => {
  return (offeringIsTypeRegA(offering) || offeringIsRegS(offering)) && !offering?.collect_additional_info || offeringIsRule506b(offering);
};
var offeringHasAdditionalInfo = (offering) => {
  return offeringIsTypeRegA(offering) || offeringIsIPO(offering) || offeringIsRule506b(offering) || offeringIsRegS(offering);
};
var offeringHidesSecurityLabel = (offering) => {
  return offering?.settings?.hide_security_label ?? false;
};
var offeringInvestorMinimumUnits = (offering) => {
  return Math.max(Number(offering?.investor_minimum_units) || 0, 1);
};

export { OfferingDisplayStatus, offeringDisplayStatus, offeringHasAdditionalInfo, offeringHasNoAccreditationStep, offeringHidesSecurityLabel, offeringInactiveWarning, offeringInvestorMinimumUnits, offeringIsActive, offeringIsClosed, offeringIsCompleted, offeringIsDraft, offeringIsIPO, offeringIsRegA, offeringIsRegAPlus, offeringIsRegD, offeringIsRegS, offeringIsRule506b, offeringIsRule506c, offeringIsTerminated, offeringIsTypeRegA, offeringIsUnitType };
